import { FC } from 'react'
import { Page, MainContent, Content } from './styled-components'
import { ThemeProvider } from 'styled-components'
import themes from 'themes'
import { RootState } from 'data/store'
import { connect } from 'react-redux'
import { PageProps } from './types'
import { AccountsSelect } from 'components/common'

const mapStateToProps = ({
  drop: { step, theme },
  user: { address, accounts }
}: RootState) => ({
  step,
  address,
  accounts,
  theme
})
type ReduxType = ReturnType<typeof mapStateToProps>

const PageComponent: FC<PageProps & ReduxType> = ({
  children,
  theme
}) => {
  const currentTheme = theme === 'light' ? themes.light : themes.dark
  return (
    <ThemeProvider theme={currentTheme}>
      <Page>
        <MainContent>
          <Content>
            {children}              
            <AccountsSelect />
          </Content>
        </MainContent>
      </Page>
    </ThemeProvider>
  );
};


export default connect(mapStateToProps)(PageComponent)
